import Person2Icon from "@mui/icons-material/Person2";
import { HOST_DOMAIN } from "../../utils/domain";
import { useBCRouting } from "../../providers/BCRoutingContextProvider";
import { styled } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { appThemeQueryOptions } from "@/api/cache/appThemeQueryOptions";
import { useUserProfile } from "@/api/cache/userProfileQueryOptions";

const TextButton = styled("div")(
  ({
    textColor,
    fontSize,
    fontWeight,
  }: {
    textColor: string;
    fontSize: number;
    fontWeight: string;
  }) => ({
    color: textColor,
    fontSize: fontSize,
    fontWeight: fontWeight,
    cursor: "pointer",
  })
);

const BCProfileButton = ({ mobile }: { mobile?: boolean }) => {
  const paramName = mobile ? "profileButtonMobile" : "profileButton";
  const bcRouting = useBCRouting();
  const { data: userProfile, isLoading: initializingProfile } =
    useUserProfile();

  const handleProfileClick = () => {
    if (userProfile) {
      bcRouting.navigate(HOST_DOMAIN + "/me", "_blank");
    } else {
      bcRouting.location.href =
        HOST_DOMAIN + "/signIn?ssoRedirectUrl=" + bcRouting.location.href;
    }
  };

  const { data: styleData } = useQuery(appThemeQueryOptions());

  const customImage =
    styleData?.inpageCheckoutComponent?.profileButton?.imageUrl;
  const customSize =
    styleData?.inpageCheckoutComponent?.profileButton?.size ?? 25;

  if (initializingProfile) {
    return null;
  }

  const textButton =
    !!styleData?.inpageCheckoutComponent?.[paramName]?.textButton;

  if (textButton) {
    const text = styleData.inpageCheckoutComponent?.[paramName]?.text;
    const textColor =
      styleData.inpageCheckoutComponent?.[paramName]?.textFontColor;
    const fontSize =
      styleData.inpageCheckoutComponent?.[paramName]?.textFontSize;
    const fontWeight =
      styleData.inpageCheckoutComponent?.[paramName]?.textFontWeight;
    return (
      <TextButton
        onClick={handleProfileClick}
        fontSize={fontSize ? +fontSize : 20}
        fontWeight={fontWeight || "normal"}
        textColor={textColor || "#ffffff"}
      >
        <span>{text}</span>
      </TextButton>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      {customImage ? (
        <div
          onClick={handleProfileClick}
          style={{
            cursor: "pointer",
            width: +customSize,
            height: +customSize,
          }}
        >
          <img
            src={customImage}
            alt="profile Icon"
            style={{
              width: +customSize,
              height: +customSize,
              objectFit: "contain",
            }}
          />
        </div>
      ) : (
        <Person2Icon onClick={handleProfileClick} />
      )}
    </div>
  );
};

export default BCProfileButton;
